import { useMsal } from "@azure/msal-react";
import { useQuery } from "@tanstack/react-query";
import { FeatureFlags, FeatureFlagsService } from "../../services/featureFlagsService";

const featureFlagsService = new FeatureFlagsService();

export const useFeatureFlags = () => {
  const { accounts } = useMsal();

  // Only fetch feature flags when user is authenticated
  const isAuthenticated = accounts.length > 0;

  return useQuery({
    queryKey: ["feature-flags"],
    queryFn: async (): Promise<FeatureFlags> => {
      return featureFlagsService.getFeatureFlags();
    },
    staleTime: 1000 * 60 * 10, // 10 minutes
    enabled: isAuthenticated, // Only run query when authenticated
  });
};
